<template>
  <div class="home-wrap">
    <div class="padding-11-15 padding-b-0">
      <div class="title-text-official">激活缴费</div>
    </div>
    <div class="package-wrap padding-0-15">
      <div class="package-scroll">
        <div class="package-list">
          <div class="package-box cur-version" v-if="!snapshot.isInitData">
            <div class="package-icon"><span class="font-10">{{snapshot.sign}}</span></div>
            <div class="package-title">{{snapshot.name}}</div>
            <div class="package-price">￥<span class="money">{{snapshot.money}}</span>/{{snapshot.days}}天</div>
            <div class="package-profit"><span class="font-11">利润分佣{{snapshot.percent}}%</span></div>
            <img class="current-img" src="../../../../assets/img/official/dangqian.png" alt="">
          </div>
          <div class="package-box" v-for="(item,index) of packageList" :key="index">
            <div class="package-icon"><span class="font-10">{{item.sign}}</span></div>
            <div class="package-title">{{getMainText(item.name)}}</div>
            <div class="package-price">￥<span class="money">{{getRMBFormate(item.money)}}</span>/
              <template v-if="item.type == 0">
                <span>{{item.days}}</span>天
              </template>
              <template v-else>
                <span>{{item.years}}</span>年
              </template></div>
            <div class="package-profit"><span class="font-11">利润分佣{{item.percent}}%</span></div>
            <div class="package-btn" @click="activate(item)">
              <span v-if="!snapshot.isInitData && getDifferMoney(item.money)>0">补差升级套餐</span>
              <span v-else>立即开通</span>
            </div>
          </div>
        </div>
      </div>
      <div class="package-info">
        <span class="font-11">基础版举例：小A关注了您的公众号，打开您的影票专属推广链接，通过竞价方式购买了2张电影票支付100元，扣除影票成本和技术服务费，订单剩余利润10元。订单放映2小时后结算，您获得70%的利润分佣，即70%*10元=7元。</span>
      </div>
    </div>
    <div class="gray"></div>
    <div class="high-level-wrap padding-0-15">
      <div class="title-text-official padding-11-0">高级进阶
        <template v-if="!snapshot.isInitData">
          <span v-if="snapshot.isProfit == 0">（开通分销功能，享受粉丝裂变高级功能）</span>
          <span v-else>有效期至{{snapshot.profitEffectTime ? snapshot.profitEffectTime:'暂无时间'}}</span>
        </template>
        <template v-else>
          <span>（开通分销功能，享受粉丝裂变高级功能）</span>
        </template>
      </div>
      <div class="package-list">
        <div class="package-box" v-if="!isError">
          <div class="package-icon"><span class="font-10">{{packageProfit.name}}</span></div>
          <div class="package-title">{{packageProfit.name}}</div>
          <div class="package-price">￥<span class="money">{{packageProfit.money}}</span>/{{packageProfit.days}}天</div>
          <div class="package-profit"><span class="font-11">粉丝裂变高级功能</span></div>
          <div class="package-btn" @click="activate">
            <span v-if="!snapshot.isInitData && snapshot.isProfit == 1">立即续费</span>
            <span v-else>立即开通</span>
          </div>
        </div>
      </div>
      <div class="package-info">
        <span class="font-11">分销功能举例：您的粉丝小A推广了小B注册，小B下单后小A可以得到一笔推广佣金（佣金比例由您自己设置）。小B再邀请小C注册下单，小B可以得到一级推广佣金，小A得到二级推广佣金。这样您的公众号系统就具备分销高级功能，粉丝裂变的更快，产生的订单收益越多。平均收益能比普通版本高出100%以上。</span>
      </div>
    </div>
    <div class="gray"></div>
    <div class="part-wrap padding-0-15">
      <div class="title-text-official padding-11-0">版本对比</div>
      <div class="table-wrapper">
        <div class="row-warp table-header">
          <div class="row-item">功能</div>
          <div class="row-item"><div>基础版</div><div class="part-tips color-3D9EFC">99-699元/年</div></div>
          <div class="row-item"><div>分销版</div><div class="part-tips color-FF4F76">2699元/年</div></div>
        </div>
        <div class="row-warp">
          <div class="row-item">获取全国影院信息</div>
          <div class="row-item"><img src="../../../../assets/img/h5/official/home_icon_tick.png"/></div>
          <div class="row-item"><img src="../../../../assets/img/h5/official/home_icon_tick_red.png"/></div>
        </div>
        <div class="row-warp">
          <div class="row-item">获取最新影片信息</div>
          <div class="row-item"><img src="../../../../assets/img/h5/official/home_icon_tick.png"/></div>
          <div class="row-item"><img src="../../../../assets/img/h5/official/home_icon_tick_red.png"/></div>
        </div>
        <div class="row-warp">
          <div class="row-item">获取即将上映影片信息</div>
          <div class="row-item"><img src="../../../../assets/img/h5/official/home_icon_tick.png"/></div>
          <div class="row-item"><img src="../../../../assets/img/h5/official/home_icon_tick_red.png"/></div>
        </div>
        <div class="row-warp">
          <div class="row-item">秒出票功能</div>
          <div class="row-item"><img src="../../../../assets/img/h5/official/home_icon_tick.png"/></div>
          <div class="row-item"><img src="../../../../assets/img/h5/official/home_icon_tick_red.png"/></div>
        </div>
        <div class="row-warp">
          <div class="row-item">特惠购票功能</div>
          <div class="row-item"><img src="../../../../assets/img/h5/official/home_icon_tick.png"/></div>
          <div class="row-item"><img src="../../../../assets/img/h5/official/home_icon_tick_red.png"/></div>
        </div>
        <div class="row-warp">
          <div class="row-item">无限制推送商品消息</div>
          <div class="row-item"><img src="../../../../assets/img/h5/official/home_icon_tick.png"/></div>
          <div class="row-item"><img src="../../../../assets/img/h5/official/home_icon_tick_red.png"/></div>
        </div>
        <div class="row-warp">
          <div class="row-item">竞价购票功能</div>
          <div class="row-item"><img src="../../../../assets/img/h5/official/home_icon_tick.png"/></div>
          <div class="row-item"><img src="../../../../assets/img/h5/official/home_icon_tick_red.png"/></div>
        </div>
        <div class="row-warp">
          <div class="row-item">绑定小程序</div>
          <div class="row-item"><img src="../../../../assets/img/h5/official/home_icon_tick.png"/></div>
          <div class="row-item"><img src="../../../../assets/img/h5/official/home_icon_tick_red.png"/></div>
        </div>
        <div class="row-warp">
          <div class="row-item">订单报表</div>
          <div class="row-item"><img src="../../../../assets/img/h5/official/home_icon_tick.png"/></div>
          <div class="row-item"><img src="../../../../assets/img/h5/official/home_icon_tick_red.png"/></div>
        </div>
        <div class="row-warp">
          <div class="row-item">推广素材库</div>
          <div class="row-item"><img src="../../../../assets/img/h5/official/home_icon_tick.png"/></div>
          <div class="row-item"><img src="../../../../assets/img/h5/official/home_icon_tick_red.png"/></div>
        </div>
        <div class="row-warp">
          <div class="row-item">会员系统</div>
          <div class="row-item"><img src="../../../../assets/img/h5/official/home_icon_tick.png"/></div>
          <div class="row-item"><img src="../../../../assets/img/h5/official/home_icon_tick_red.png"/></div>
        </div>
        <div class="row-warp">
          <div class="row-item">粉丝维度模块</div>
          <div class="row-item"></div>
          <div class="row-item"><img src="../../../../assets/img/h5/official/home_icon_tick_red.png"/></div>
        </div>
        <div class="row-warp">
          <div class="row-item">用户裂变模块</div>
          <div class="row-item"></div>
          <div class="row-item"><img src="../../../../assets/img/h5/official/home_icon_tick_red.png"/></div>
        </div>
        <div class="row-warp">
          <div class="row-item">自定义域名</div>
          <div class="row-item"></div>
          <div class="row-item"><img src="../../../../assets/img/h5/official/home_icon_tick_red.png"/></div>
        </div>
        <div class="row-warp">
          <div class="row-item">自定义消息回复</div>
          <div class="row-item"></div>
          <div class="row-item"><img src="../../../../assets/img/h5/official/home_icon_tick_red.png"/></div>
        </div>
        <div class="row-warp">
          <div class="row-item">自定义邀请海报</div>
          <div class="row-item"></div>
          <div class="row-item"><img src="../../../../assets/img/h5/official/home_icon_tick_red.png"/></div>
        </div>
        <div class="row-warp">
          <div class="row-item">所有辅助软件</div>
          <div class="row-item"></div>
          <div class="row-item"><img src="../../../../assets/img/h5/official/home_icon_tick_red.png"/></div>
        </div>
      </div>
    </div>
    <Activate ref="Activate"></Activate>
  </div>
</template>

<script>
import { getPlatformUuid, getUserUUID,getSnaphotId,getIsBasic } from '@/utils/auth'
import { Table, Icon } from 'view-design'
import Activate from '@/views/h5/official/activation/modal/Activate.vue'
import activation from '@/javaApi/activation'
import { Modal } from 'view-design'
const activationModel = new activation()
export default {
  name: "Activation",
  components: {
    Table,
    Icon,
    Activate
  },
  data: function () {
    return {
      isError:true,
      loading:true,
      packageList:[],
      snapshot:{
        name:'暂无套餐',
        effectTime:'0000-00-00',
        money:0,
        isInitData:true
      },
      packageProfit:{},
      linkPath:{
        path:'/pc/pay/list',
        query:{
          platformUuid:getPlatformUuid(),
          isProfit: 1,
          packageId:0,
          type: 4,
          snapshotId:0
        }
      },
      jsonObject:{

      },
      platformUuid:getPlatformUuid()
    }
  },
  created(){
    this.getPackageList()
  },
  methods:{
    getPackageList(){
      let queryParam = this.$route.query
      let nowSnapshotId = getSnaphotId()?(getSnaphotId() == 'null')?0:getSnaphotId():0
      let addPub = (queryParam.isNew)?true:false
      if(nowSnapshotId == -1){
        addPub = true
      }
      if(nowSnapshotId == -1){
        nowSnapshotId = 0
      }
      let param = {
        openUserUuid: getUserUUID()?getUserUUID():'',
        addPub:addPub,
        snapshotId:nowSnapshotId
      }
      let platformUuid = getPlatformUuid();
      let condition = (platformUuid == '' || platformUuid == 0);
      if(!condition){
        param.platformUuid = platformUuid
      }
      let that = this
      activationModel.getPackageList(param).then(response=>{
        that.loading = false
        let res = response.data
        if(res.code === 200){
          if(res.data){
            if(res.data.list){
              this.isError = false
              that.packageList = res.data.list
              if(res.data.snapshot){
                this.linkPath.query.snapshotId = res.data.snapshot.id
              }
              if(that.packageList.length>0){
                let i =0;
                for(i;i<that.packageList.length;i++){
                  //   let currentMoney =   parseFloat(money)
                  let snapshotMoney = 0
                  let templateSnapshotId = 0
                  if(res.data.snapshot){
                    snapshotMoney = parseFloat(res.data.snapshot.money)
                    this.linkPath.query.snapshotId = res.data.snapshot.id
                    templateSnapshotId = res.data.snapshot.id
                  }
                  let money =  that.packageList[i]['money']
                  if((snapshotMoney - money)== 0){
                    that.packageList[i]['linkPath'] = {
                      path:'/pc/pay/list',
                      query:{
                        platformUuid:getPlatformUuid(),
                        packageId:that.packageList[i]['id'],
                        type: 3,
                        snapshotId:templateSnapshotId
                      }
                    }
                  }else{
                    // 是否过期了 过期就调用立刻续费的接口
                    let now = this.$moment()
                    let timeDiff = -1
                    if(res.data.snapshot){
                      let effectTime = this.$moment(res.data.snapshot.effectTimeStr)
                      timeDiff= effectTime.diff(now)
                    }
                    if(timeDiff>=0){
                      // 补差升级的url
                      that.packageList[i]['linkPath'] = {
                        path:'/pc/pay/list',
                        query:{
                          platformUuid:getPlatformUuid(),
                          isProfit: 0,
                          packageId:that.packageList[i]['id'],
                          type: 1,
                          snapshotId:templateSnapshotId
                        }
                      }
                    }else{
                      // 立刻续费的url
                      that.packageList[i]['linkPath'] = {
                        path:'/pc/pay/list',
                        query:{
                          platformUuid:getPlatformUuid(),
                          packageId:that.packageList[i]['id'],
                          type: 3,
                          snapshotId:templateSnapshotId
                        }
                      }
                    }
                  }

                }
              }
            }

            if(res.data.snapshot){
              that.snapshot = res.data.snapshot
            }
            if(res.data.packageProfit){
              that.packageProfit = res.data.packageProfit
              that.linkPath.query.packageId =res.data.packageProfit.id
            }

          }

        } else {
          let message = res.message?res.message:'系统异常请稍后再试！'
          that.$message.error(message)
        }
      }).catch(error=>{
        if(error != 'token invalid'){
          that.$message.error('系统异常请稍后再试！')
        }
        that.loading = false
      })
    },
    getRMBFormate(money){
      return parseFloat(money).toFixed(2)
    },
    getDifferMoney(money){
      let currentMoney =  parseFloat(money)?parseFloat(money):0
      let snapshotMoney = parseFloat(this.snapshot.money)?parseFloat(this.snapshot.money):0
      return (currentMoney - snapshotMoney).toFixed(2)
    },
    getRestOfDay(createTime){
      let _d_tm = new Date(new Date().valueOf());
      let _d_now = new Date(new Date().valueOf());
      if(createTime){
        _d_now = new Date((createTime).replace(/-/g, "/"));
      }
      if(_d_now<_d_tm){
        return '已过期'
      }
      let leftTime =  ~~((_d_now - _d_tm) / 1000 / 60 / 60 / 24);
      return  leftTime+'天'
    },
    getMainText(item){
      return item.substr(0,8)
    },
    getSubText(item){
      let lastLen = (item.length>=32)?32:item.length
      return item.substr(8,lastLen)
    },
    showTip(){
      let that = this
      Modal.warning({
        title: '提示',
        content: '请先去绑定公众号',
        onOk: function() {
          if(getIsBasic() === 'true'){
            that.$store.dispatch('nav/changeOfficialAccountActiveIndex',4)
          }else{
            that.$store.dispatch('nav/changeOfficialAccountActiveIndex',7)
          }
          that.$router.push('/h5/official/authorization').catch(err => { err })
        }
      })
    },
    activate() {
      this.$refs.Activate.init()
    }
  }
}
</script>

<style lang="less" scoped>
.package-wrap{
  font-family: PingFangSC-Regular;
  .package-scroll{
    overflow-x: scroll;
  }
}
.package-list{
  display: flex;
  margin: 21px 0 20px;
  .package-box{
    background: #FFFFFF;
    border: 1px solid #E8E8E8;
    border-radius: 4px;
    padding: 15px;
    position: relative;
    text-align: center;
    width: 150px;
    white-space: nowrap;
    margin-right: 10px;
    .package-icon{
      position: absolute;
      top: -10px;
      left: 0;
      background: #FF4F76;
      border-radius: 8px 0 8px 0;
      color: #FFFFFF;
      padding: 1px 5px;
    }
    .package-title{
      margin-top: 5px;
      font-size: 14px;
      color: #222222;
      width: 120px;
      line-height: 20px;
    }
    .package-price{
      font-family: Alibaba-PuHuiTi-M;
      font-size: 12px;
      color: #222222;
      margin: 15px auto;
      line-height: 32px;
      .money{
        font-size: 24px;
        color: #222222;
        line-height: 33px;
      }
    }
    .package-profit{
      font-family: Alibaba-PuHuiTi-R;
      color: #999999;
      line-height: 15px;
    }
    .package-btn{
      background: #FF8622;
      font-family: Alibaba-PuHuiTi-R;
      font-size: 14px;
      color: #FFFFFF;
      text-align: center;
      padding: 5px 0;
      margin-top: 15px;
      line-height: 16px;
    }
  }
  .cur-version{
    background: #FFF2E8;
    border: 1px solid #FF8622;
    color: #FF8622;
    .current-img {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 64px;
    }
  }
}
.package-info{
  font-family: Alibaba-PuHuiTi-R;
  color: #999999;
  text-align: justify;
  margin-bottom: 20px;
}
.high-level-wrap{
  .title-text-official span{
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #999999;
    line-height: 17px;
  }
}
.part-wrap{
  padding-bottom: 40px;
}
.table-wrapper{
  border: 1px solid #E8E8E8;
  .row-warp{
    display: flex;
    align-items: center;
    .row-item{
      width: 33%;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      padding: 10px 0 10px 10px;
      font-family: Alibaba-PuHuiTi-R;
      font-size: 12px;
      color: #222222;
      img{
        width: 22px;
      }
    }
    .row-item:first-child{
      width: 40%;
    }
  }
  .row-warp:nth-child(2n){
    background: #FAFAFA;
  }
  .table-header{
    .row-item{
      font-family: Alibaba-PuHuiTi-M;
      font-size: 14px;
      color: #222222;
      text-align: justify;
      .part-tips{
        font-size: 12px;
        line-height: 17px;
        margin-top: 5px;
      }
      .color-3D9EFC{
        color: #3D9EFC;
      }
      .color-FF4F76{
        color: #FF4F76;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/h5/official/activation/Index.vue